import React from 'react';
import { useTranslation } from 'react-i18next';
import MultiSelect from './MultiSelect';

/**
 * Visible-columns picker shared across V3 reports. Thin wrapper around
 * MultiSelect that renders the "Visible columns (n/total)" label and feeds
 * useColumnConfig.
 *
 *   options  — columnOptions from useColumnConfig ([{ value, label }])
 *   value    — selectedColumns
 *   total    — full column count (for the n/total counter)
 *   onChange — useColumnConfig.onChange
 *   maxChips — chips before collapsing to "+N more" (default 2)
 */
const ColumnPicker = ({ options, value, total, onChange, maxChips = 2 }) => {
    const { t } = useTranslation();
    return (
    <div className="v3-report-field" style={{ maxWidth: 360 }}>
        <span className="v3-label">{t('Visible columns ({{count}}/{{total}})', { count: value.length, total })}</span>
        <MultiSelect
            value={value}
            options={options.map((o) => ({ ...o, label: t(o.label) }))}
            placeholder={t('Choose columns…')}
            maxChips={maxChips}
            onChange={onChange}
        />
    </div>
    );
};

export default ColumnPicker;
